module.exports = __webpack_public_path__ + "static/media/icon-search.f2008a53.svg";